import { GA_TAGS } from './analytics';

export const VALUE_TRACKER_GA_TAGS = GA_TAGS;
